import axios from 'axios';

import { TOKEN_KEY } from './TokenManager';
import { CLIENT_ID, SECRET_KEY } from './index';
import { baseURL } from './url';
import { encrypt } from './encodingdecoding';

let refreshPromise = null;

const getNewAuthToken = () => {
	if (refreshPromise) return refreshPromise;

	refreshPromise = (async () => {
		try {
			const formData = {
				client_id: CLIENT_ID,
				secret_key: SECRET_KEY,
			};
			const response = await axios.post(
				`${baseURL}fulfilmentTokenLive`,
				formData,
				{
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
				},
			);
			const token = response?.data?.message?.data?.access_token;

			localStorage.setItem(TOKEN_KEY, token);
			return token;
		} catch (err) {
			throw err;
		} finally {
			refreshPromise = null;
		}
	})();

	return refreshPromise;
};

export default getNewAuthToken;
